import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { clone as cloneSkeleton } from "three/examples/jsm/utils/SkeletonUtils.js";

export interface LoadedModel {
  scene: THREE.Group;
  animations: THREE.AnimationClip[];
}

const loader = new GLTFLoader();
const cache = new Map<string, Promise<LoadedModel>>();

/** Loads (and caches) a GLB by URL. Safe to call repeatedly for the same URL. */
export function loadModel(url: string): Promise<LoadedModel> {
  let pending = cache.get(url);
  if (!pending) {
    pending = loader.loadAsync(url).then((gltf) => ({ scene: gltf.scene, animations: gltf.animations }));
    cache.set(url, pending);
  }
  return pending;
}

/**
 * Deep-clones a loaded (skinned) model for a new instance. A plain
 * Object3D.clone() does not correctly re-bind skeletons shared across
 * clones — SkeletonUtils.clone handles that, which matters here since many
 * players reuse the same source GLB simultaneously.
 */
export function cloneModel(loaded: LoadedModel): LoadedModel {
  return { scene: cloneSkeleton(loaded.scene) as THREE.Group, animations: loaded.animations };
}
